<!--
@Author: Tom Voorneveld <tom>
@Date:   2017-11-23T10:24:36+01:00
@Email:  tom@lorinthe.com
@Project: Lorinthe - Footer for eacxh page
@Last modified by:   tom
@Last modified time: 2019-05-17T10:20:14+02:00
@Copyright: (c) copyright Lorinthe BV, all rights reserved
-->

<template lang="html">
  <b-navbar
    id="footer-bar"
    toggleable="md"
    type="dark"
    variant="primary">
    <b-container id="footer">
      <div class="tab-row">

        <!-- Columns start at 8/12 wide on mobile and bump up to 10/12 wide on desktop -->
        <div id="footer-info" class="table-col">
          <router-link :to="{name:'upgrade'}"> v{{ version }}&nbsp;&nbsp;</router-link>
          <span v-html="$t('footer.copyright') + ' ' + thisYear + ' ' + $t('footer.terms')"/>
        </div>

        <!-- ** About us ** -->
        <!-- <b-navbar-nav class="pr-4 pl-2 table-col">
          <b-nav-item-dropdown :text="$t('about_us.label')" right class="dropup">
            <b-dropdown-item :to="{name:'about'}" v-html="$t('about_us.label')"/>
            <b-dropdown-item :to="{name:'career'}" v-html="$t('career.label')"/>
          </b-nav-item-dropdown>
        </b-navbar-nav> -->

        <social-share-button
          id="nf-sm-icon"
          :hashtags="$t('title.hashtags')"
          :title="$t('title.slogan')"
          :description="$t('title.subtitle')"
          :quote="$t('intro.1.payload')"
          class="table-col"/>

      </div>
    </b-container>
  </b-navbar>
</template>

<script>

import Log from '@/lib/log'

// To use the package.json version number in our code, please add to your webpack.config.js
//   plugins: [
//     new webpack.DefinePlugin({
//       VERSION: JSON.stringify(require("../package.json").version)
//     })
//   ]

/* global VERSION */
Log.n('Version: ' + VERSION)

export default {
  computed: {
    thisYear: function () {
      return new Date().getFullYear()
    },
    version: function () {
      return VERSION
    },
    versionUnderScore: function () {
      return VERSION.replace(/\./g, '_')
    }
  }
}

</script>

<style lang="scss">
  #footer-bar {
    border-top: 1px solid $primaryHighlight;
    padding-top: 8px;
    padding-bottom: 4px;

    .nav-item {
      font-size: 1.2em;
    }

    // the container
    #footer {
      display: table;
      padding: 0;
      // padding: 0.5rem .5rem 10px;
      font-size: 0.85em;
      line-height: 1em;
      color: $primaryWhite;
      .tab-row {
        display: table-row;
        .table-col {
          display: table-cell;
        }
      }
      #footer-info, #nf-sm-icon {
        padding-right: 8px;
        opacity: 0.6;
        a, span {
          color: $primaryWhite;
        }
      }

    }
  }

</style>
